/*==============================================================*\
|| 					------	BINDERS  ------						||
\*==============================================================*/


/*------------------------------------------------------*\
|| 	1.0	Templates			 							||
\*------------------------------------------------------*/

	/*jshint multistr: true */
//
var $binder = _.template(`
	<a id="<%= BINDER_ID %>"
	href="<%= BINDER_URL %>"
	data-binder="<%= BINDER_ID %>"
	binder-name="<%= BINDER_NAME %>"
	class="binder container-list dragula-container<% if ( NEW_BINDER ) { %> new-binder<% } %>">
		<div class="binder-inner no-drag">
			<span class="binder-name no-drag"><%= BINDER_NAME %></span>
			<span class="edit-this-binder no-drag"></span>
			<span class="delete-this-binder no-drag"></span>
			<div class="button button-filled button-alert button-not-clickable button-tiny confirm-binder-del no-drag">verwijder</div>
		</div>
		<div class="is-active-caret no-drag"></div>
	</a>
`);

var simple_binder = _.template(`
	<div data-binder="<%= BINDER_ID %>" binder-name="<%= BINDER_NAME %>" class="binder">
		<div class="binder-inner no-drag">
			<span class="binder-name no-drag"><%= BINDER_NAME %></span>
			<span class="binder-status" data-icon>Toegevoegd</span>
			<span class="binder-remove-fav" data-icon>Verwijderen</span>
		</div>
	</div>
`);

var form = _.template(`
	<div class="edit-binder-form">
		<div class="border-animation"></div>
		<div class="input-wrapper">
			<input id="rename-input" type="text" value="<%= BINDER_NAME %>">
			<button type="submit" id="edit-binder" class="edit-binder button button-filled button-alert button-not-clickable" data-binder="<%= DATA_BINDER %>">opslaan</button>
		</div>
	</div>
`);


/*------------------------------------------------------*\
|| 	2.0	Functions			 							||
\*------------------------------------------------------*/

function binder( action, id, name, index ) {
    return $.ajax({
        type: "POST",
        url:  KWR.ajaxurl,
        dataType: 'json',
        data: {
            action: 'Binder',
            ajax_action: action,
            binder_id: id,
            binder_name: name,
            posts_per_page: 3,
            binder_index: index 
        },

        success: function(response) {
            if(response.success === true ) {
            }
        },

        error: function(response) {
        }
    });
}

/*------------------------------------------------------*\
|| 	3.0	Creating a new binder 							||
\*------------------------------------------------------*/
// Button that needs to be clicked in order to show the input form to create new binder
$('body').on('click', '.new-binder', function(e){
	e.preventDefault();
	var $parent = $(this).parent('.add-binder'),
		$wrapper = $parent.find('.input-wrapper'),
		text = $parent.children('a').text();

	$parent.addClass('active');
	$('.create-binder-form input[type=text]').focus();
});

// This the form which creates the new binder
// - This function only executes an animation to hide the form
$('body').on( 'click', '.create-binder', function(){
	// Set variables
	var $parent = $(this).parent().parent().parent('.add-binder'),
		$wrapper = $parent.find('.input-wrapper'),
		name = $(this).prev('input[type="text"]').val(),
		$url = $('.binder-list').attr('data-url'),
		id = randomString(10, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');

	// Remove active class
	$parent.removeClass('active');
	// Empty the value
	$wrapper.children('#create-binder-input').val('');

	//setTimeout(function(){
	var publication = $('.post').attr('data-id');
	var binder_list = $('.binder-list');
	var createFolder = binder('create', id, name, null)
			.then(function (response) {

				if ( !$('body').hasClass('page-template-publicaties') ) {
					$('.binder-list').append(
						$binder({
							BINDER_NAME: name,
							BINDER_ID: id,
							BINDER_URL: $url + id,
							NEW_BINDER: true
						})+'<hr>'
					);
				} else {
					var publication = $('.post').attr('data-id');
					$('.binder-list').append(
						simple_binder({
							BINDER_NAME: name,
							BINDER_ID: id,
						})+'<hr>'
					);
					return addToBinder(publication, response.data._id);
				}
				return false;
			}).then(function (response) {
					if(response.success) {
						var star = $('.article-top-bar .icon-star-full'),
							binder_id = response.data.binder_id,
							binder = $('[data-binder="'+binder_id+'"');
						binder.addClass('in-binder');
						star.addClass('is-favorited');
					}
			});
});

// When the user executes a certain keycommand such as 'Enter' or 'Escape'
$('.create-binder-form, body').on('keydown', 'input', function(e) {
	var $submit = $(this).next();

    if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) {
        $submit.click();
        return false;
    } else if ((e.which && e.which == 27) || (e.keyCode && e.keyCode == 27)) {
    	var $parent = $(this).parent().parent().parent('.add-binder'),
    		$wrapper = $parent.find('.input-wrapper');

    	$parent.removeClass('active');
    	$wrapper.children('#create-binder-input').val('');

    } else {
        return true;
    }
});


/*------------------------------------------------------*\
|| 	4.0	Renaming a binder 								||
\*------------------------------------------------------*/
// Button to be clicked when renaming the binder
$('.block').on('click', '.edit-this-binder', function(e){
	e.preventDefault();
	var $theBinder = $(this).closest('.binder'),
		attr = $theBinder.attr('data-binder'),
		name = $theBinder.closest('.binder').find('span.binder-name').text();

	/*jshint multistr: true */
	$('.block .binder[data-binder="' + attr + '"]').removeClass('dragula-container').addClass('rename-binder animating')
	.append(
		form({
			BINDER_NAME: name,
			DATA_BINDER: attr,
		})
	).removeClass('binder');

	setTimeout(function(){
		$('.rename-binder[data-binder="' + attr + '"]').addClass('active').removeClass('animating');
	}, 200);

	$('.rename-binder[data-binder="' + attr + '"]').children('span a').remove();

	setTimeout(function () {
		$theBinder.find('#rename-input').focus();
	}, 500);

});

// What happens when you 'submit' the renaming
$('.block').on( 'click', '.edit-binder', function () {
	var attr = $(this).attr('data-binder'),
		$container = $('.container-list[data-binder="'+attr+'"]'),
		name = $container.children('.edit-binder-form').children('.input-wrapper').children('input[type="text"]').val(),
		$url = $('.binder-list').attr('data-url'),
		id = $container.attr('id'),
		index = $container.attr('data-index') - 1;


	$.when( binder('rename', id, name, index) ).done( function(){
		$('.container-list[data-binder="'+attr+'"]').removeClass('active');

		setTimeout(function(){
    		$('.container-list[data-binder="'+attr+'"]').addClass('binder dragula-container')
    		.replaceWith(
				$binder({
					BINDER_NAME: name,
					BINDER_ID: id,
					BINDER_URL: $url + id,
					NEW_BINDER: false
				})
			).removeClass('rename-binder');
    	}, 200);
	});
});

$('.block').on('keydown', 'input', function(e) {
	var $submit = $(this).next();

	if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) {
   	$submit.click();
   	return false;
 	} else if ((e.which && e.which == 27) || (e.keyCode && e.keyCode == 27)) {
 		var $parent = $(this).parent().parent().parent('.container-list'),
 			$wrapper = $parent.find('.edit-binder-form');

 		$parent.removeClass('active');
 		setTimeout(function(){
    		$parent.addClass('binder dragula-container');
    		$wrapper.remove();
    		$parent.removeClass('rename-binder');
 		}, 200);

 	} else {
   	return true;
 	}
});


/*------------------------------------------------------*\
|| 	5.0	Deleting a binder 								||
\*------------------------------------------------------*/
// Trigger delete modal
$(document).on('click', function (e) {
	if(!$(e.target).hasClass('delete-this-binder') && !$(e.target).hasClass('confirm-binder-del')) {
		$('.binder.js-confirm').removeClass('js-confirm');
	}
});

$('.block').on('click', '.delete-this-binder', function(e){
	//e.stopPropagation();
	$(this).closest('.binder').addClass('js-confirm');
	/*var $binderID = $(this).closest('.binder').attr('data-binder'),
	$binderName = $(this).closest('.binder').attr('binder-name');

	$('.reveal .name').text( $binderName );
	$('.reveal .button[data-delete]').attr('data-delete', $binderID );*/
});

$('.block').on('click', '.confirm-binder-del', function (e) {
	e.preventDefault();
	e.stopPropagation();
	var $binder = $(this).closest('.binder');
	var id = $binder.attr('data-binder');

	$.when( binder('delete', id, null, null) ).done( function(){
		$binder.next('hr').remove();
		$binder.remove();
	});
});

// Delete binder after confirming with the modal
/*$('.reveal').on('click', '.button[data-delete]', function(){
	var id = $(this).attr('data-delete'),
		$binder = $('.block .binder[data-binder="' + id + '"');

	$.when( binder('delete', id, null, null) ).done( function(){
		$binder.next('hr').remove();
		$binder.remove();
	});

});*/

/*------------------------------------------------------*\
|| 	6.0	Prevent switching binders while editing 		||
\*------------------------------------------------------*/
$('.block').on('click', 'a', function(e){
	if ( $('body').hasClass('edit-favorites')) {
		e.preventDefault();
	}
});

/*------------------------------------------------------*\
|| 	7.0	Add class to the active binder 					||
\*------------------------------------------------------*/ 
if ( document.getElementsByTagName('body')[0].classList.contains('logged-in') && document.getElementsByTagName('body')[0].classList.contains('favorites-page') ) {
	if (document.location.pathname.replace(/(\/)(en)?(favorieten)?(favorites)?/gi, '') !== '') {
		var binderId = document.location.pathname.replace(/(\/)(en)?(favorieten)?(favorites)?/gi, '');
	} else {
		var binderId = 'default';
	}
	// remove this later!!
	var binderId = 'default';
	// console.log(document.location.pathname);

	var el = document.getElementById(binderId);

	document.getElementById(binderId).classList.add('current-binder');
	document.getElementById(binderId).classList.remove('dragula-element');
}

